module.exports = __webpack_public_path__ + "static/media/unagi_vakame.47ec7d70.jpeg";